import styled from 'styled-components'
import { getScollerCSS } from '@components/Scroller/style'

export const BulkInstructors = styled.div`
  ${getScollerCSS({
    border: '1px solid #cacaca',
    bgColor: '#cacaca',
  })}

  ${({ theme }) => `
    max-height: calc(650px - 65px - 8px);
    overflow: auto;
    border: 1px solid ${theme.palette.gray60};
    border-radius: 2px;
    padding: 9px 10px;
    margin-top: 8px;
    background-color: ${theme.palette.white};
    color ${theme.palette.charcoal};

    h1 {
      margin-bottom: 14px;
      font-size: ${theme.fontSize.sm};
      font-weight: ${theme.fontWeight.bold};
      font-stretch: normal;
      font-style: normal;
      line-height: 1.22;
      letter-spacing: 0.63px;
    }

    [role="radiogroup"] {
      margin-bottom: 0px;

      label {
        span {
          align-self: flex-start;
          margin-top: -1px;
          margin-right: 4px;
        }
      }
    }
  `}
`

export const BulkInstructorItem = styled.div`
  ${({ theme }) => `
    font-size: ${theme.fontSize.xxs};
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.14;
    letter-spacing: 0.49px;
    margin-bottom: 8px;
  `}
`

export const GroupedRadioLabel = styled.div`
  ${({ theme }) => `
    color: ${theme.palette.gray100};
    font-size: ${theme.fontSize.xxs};
    font-weight: ${theme.fontWeight.bold};
    font-stretch: normal;
    font-style: normal;
    line-height: 1.14;
    letter-spacing: 0.49px;
    display: flex;
    align-items: center;
    margin-top: 8px;

    span {
      margin-bottom: 8px;
      margin-right: 6px;
      flex-shrink: 0;
    }

    div {
      border-top: 1px solid ${theme.palette.gray30};
      border-radius: 3px;
      width: 100%;
      height: 0px;
      margin-bottom: 8px;
    }
  `}
`
